export const apiVersion = 'v1';
export const baseUrl = `${process.env.REACT_APP_API_URL}/${apiVersion}`;
export const baseUrlV2 = `${process.env.REACT_APP_API_URL}/v2`;
export const wsUrl = `${process.env.REACT_APP_WS_URL}`;
export const returnBaseUrl = process.env.REACT_APP_RETURN_BASE_URL;
export const version = process.env.REACT_APP_VERSION;
export const isHunger = process.env.REACT_APP_COMPANY === 'hunger-hunger';
export const companyName = isHunger ? 'hunger-hunger' : 'BestellEck';
export const geoEndpoint = `https://bestelleck.de/geo`;
